import React from 'react'
import { Modal, Table } from '@pankod/refine-antd'

import { TCertificateTTEParticipant } from '../types'
import { formatTextValue } from '../display'
import useTableWithMeta from 'src/hooks/useTableWithMeta'

interface TParticipantsModalProps {
  open: boolean
  submissionId: string | null
  onClose: () => void
}

export const ParticipantsModal: React.FC<TParticipantsModalProps> = ({
  open,
  submissionId,
  onClose,
}) => {
  const { tableProps } = useTableWithMeta<TCertificateTTEParticipant>({
    resource: `certificate-tte-submissions/${submissionId}/participants`,
    dataProviderName: 'lms',
    queryOptions: {
      enabled: !!submissionId && open,
    },
  })

  return (
    <Modal
      open={open}
      title="Daftar Penerima"
      footer={null}
      onCancel={onClose}
      width={600}
      destroyOnClose
    >
      <Table<TCertificateTTEParticipant>
        {...tableProps}
        rowKey={(record, index) => record.nip || record.nama || String(index)}
        size="small"
        bordered
      >
        <Table.Column<TCertificateTTEParticipant>
          title="Nama"
          dataIndex="nama"
          render={(value) => formatTextValue(value)}
        />
        <Table.Column<TCertificateTTEParticipant>
          title="NIP"
          dataIndex="nip"
          width={200}
          render={(value) => formatTextValue(value)}
        />
      </Table>
    </Modal>
  )
}
